import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { InfoModal } from './InfoModal';
import { usePermissionNoticeStore } from './permission-notice.store';

/**
 * Renders the 권한 없음 modal for a page the admin may not open (SHCT-171).
 *
 * Mounted inside `AdminLayout` rather than at the app root next to {@link SessionNoticeHost}: this one
 * needs `useNavigate`, and the root mount sits outside the router. Every permission-gated page lives
 * under this layout, so one instance covers all of them.
 *
 * Acknowledging is what redirects. The gated page has already rendered nothing, so leaving the user
 * on its empty route would strand them; sending them to /home on dismiss follows the SHCT-448
 * precedent (Counseling Manual) instead of navigating out from under the dialog they are still
 * reading. PRD 21 §7.2 does not define a destination for 권한 없음 — only the modal and its copy — so
 * the existing precedent is followed rather than a new rule invented.
 */
export function PermissionNoticeHost() {
  const { t } = useTranslation('common');
  const open = usePermissionNoticeStore((s) => s.open);
  const clear = usePermissionNoticeStore((s) => s.clear);
  const navigate = useNavigate();

  return (
    <InfoModal
      open={open}
      title={t('gate.noPermission.title')}
      body={t('gate.noPermission.notice')}
      onClose={() => {
        clear();
        navigate('/home', { replace: true });
      }}
    />
  );
}
